<div class="typeahead-search"
     [ngClass]="{'typeahead-search__active': typeaheadInput.value.length || selectedItem,
                 'typeahead-search__focused': isFocused,
                 'typeahead-search__error': invalidSelection}">

  <span class="typeahead-search__magnifier"
        [class.magnifier-disabled]="typeaheadInput.value.length < 1"
        (click)="search(typeaheadInput.value)">
    <i class="lx-icon lx-search"></i>
  </span>

  <input #typeaheadInput
         type="text"
         (blur)="onBlur()"
         [style.width]="'100%'"
         placeholder="Enter Serial Number"
         (input)="search($event)" />

  <span class="typeahead-search__cancel"
        *ngIf="typeaheadInput.value.length > 0"
        (click)="clearSearch()">
    <i class="lx-icon lx-close-x"></i>
  </span>
</div>